/**
 * This file defines the main structure and logic of the React application.
 * It imports and uses various components and includes Bootstrap for styling.
 *
 * Author: Meng Li
 * Created on: 2024-09-30
 * Professor: Mejdi Eraslan
 * Client: Melisa Eraslan
 */

import React from 'react';

import { Routes, Route } from 'react-router-dom'; // Importing Routes and Route for routing
import CustomNavbar from './assets/components/Navbar'; // Importing the Custom Navbar component
import Welcome from './assets/js/Welcome';
import Map from './assets/js/Map';
import Directory from './assets/js/Directory';
import EntityInfo from './assets/js/EntityInfo';
import About from './assets/js/About';
import Contact from './assets/js/Contact';
import Login from './assets/js/Login';
import UserPanelSidebar from './assets/components/UserPanelSidebar';
import AccountDetails from './assets/js/AccountDetails';
import EntityDetails from './assets/js/EntityDetails';
import EntityDetailsAdmin from './assets/js/EntityDetailsAdmin';
import EntityDetailsForAdmin from './assets/js/EntityDetailsForAdmin';
import AddNewAccount from "./assets/js/AddNewAccount";
import AddNewEntity from "./assets/js/AddNewEntity";

import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
    return (
        <div>
            <CustomNavbar /> {/* Navigation bar component */}
            <Routes>
                {/* Define the routes for each component/page in the application */}
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/map" element={<Map />} />
                <Route path="/directory" element={<Directory />} />
                <Route path="/entityInfo" element={<EntityInfo />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/userPanelSidebar" element={<UserPanelSidebar />} />
                <Route path="/accountDetails" element={<AccountDetails />} />
                <Route path="/entityDetails" element={<EntityDetails />} />
                <Route path="/entityDetailsAdmin" element={<EntityDetailsAdmin />} />
                <Route path="/entityDetailsAdmin/:entityId" element={<EntityDetailsForAdmin />} />
                <Route path="/addNewAccount" element={<AddNewAccount />} />
                <Route path="/addNewEntity" element={<AddNewEntity />} />
            </Routes>
        </div>
    );
};

export default App;
